import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React from "react";
import { useTrainDetail } from "./useTrainDetail";
import { trainSections } from "./trainSections";
import { type LinkShowToTravelConfig } from "components/LinkShowToTravelButton";

interface Props {
  train: server.dto.Train
  linkedShows: server.dto.LinkedShow[]
  linkShowToTravel: LinkShowToTravelConfig
  travellers: server.dto.ContactSmallV2[]
  files: server.dto.File[]
  onArtistChanged: (newArtist: server.dto.ArtistSmall) => void
  onDateChanged: (newDate: server.dto.AppointmentDateTime) => void
  onStatusChanged: () => void
}

export const TrainDetailSection = (props: Props) => {
  const {
    state,
    onValueChanged,
    onSuccessfulUpdate,
    refetchFiles,
    getUpdateTrainDetails,
  } = useTrainDetail(
    props.train,
    props.travellers,
    props.files,
    props.onArtistChanged,
    props.onDateChanged,
    props.onStatusChanged,
  );

  return <DetailSectionTemplate
    isInPageEditable={props.train.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdate}
    sections={trainSections(state, props.linkedShows, refetchFiles, getUpdateTrainDetails, props.linkShowToTravel)}
  />
}
